import { axios } from "@/utils";

export type Customer = {
    orderId: string;
    isGlobal: boolean;
    customerId?: string;
    cc_list?: string[];
  };

export const createElectronicBill = async (data: Customer) => {
    const response = await axios.post(`/electronic-invoice`, data);
    return response.data;
  };
  